module.exports = __webpack_public_path__ + "static/media/check-green.649ba495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check-green.svg
// module id = 262
// module chunks = 0